import { SWRConfiguration } from "swr";
import useSWRInfinite from "swr/infinite";
import { WithPaginationMetaResponse, InfiniteLoadingReturn } from "../types";
import { useScrollEffect } from "./useScrollEffect";

export const useSWRInfiniteWithScroller = <T>(
  key: (
    pageIndex: number,
    previousPageData: WithPaginationMetaResponse<T>
  ) => string,
  fetcher: (url: string) => Promise<WithPaginationMetaResponse<T>>,
  options?: SWRConfiguration
): InfiniteLoadingReturn<T> => {
  const {
    data: pages,
    size,
    setSize,
    isValidating,
    ...rest
  } = useSWRInfinite(key, fetcher, options);

  const onScroll = (
    clientHeight: number,
    innerHeight: number,
    scrollY: number
  ) => {
    if (!pages) return;
    const totalPages = pages[0]?.meta?.totalPages || 0;

    if (clientHeight === innerHeight + scrollY && size < totalPages) {
      setSize(size + 1);
    }
  };

  useScrollEffect(onScroll);

  const isInitialLoading = !pages && isValidating;
  const isLoadingMore = pages && isValidating;

  return {
    data: pages,
    size,
    setSize,
    isValidating,
    ...rest,
    isInitialLoading,
    isLoadingMore,
  };
};
